/* Size prompt + remembered size. Fork-local, 2026-10-22.
   Spec: docs/superpowers/specs/2026-10-22-plp-size-prompt.md

   Two pages use this file:
   - collection and search pages, where snippets/size-prompt.liquid renders the prompt;
   - the product page, where snippets/size-guide.liquid loads it for the saved-size preselect.

   The saved size is localStorage['ih.size.v1'] = {"size": "M"}, written only while
   "Remember my size" is ticked. A saved size is APPLIED to a collection before paint by the
   inline script snippets/size-prompt.liquid renders in <head> (mode 'head'); this file only
   keeps the prompt in step with the URL after that. */
(function () {
  var KEY = 'ih.size.v1';
  var PARAM = 'filter.v.option.size';
  var skipKey = 'ih.size.skip:' + location.pathname;

  function savedSize() {
    try { var v = JSON.parse(localStorage.getItem(KEY) || 'null'); return v && v.size ? String(v.size) : null; }
    catch (e) { return null; }
  }
  function saveSize(size) {
    try { if (size) localStorage.setItem(KEY, JSON.stringify({ size: size })); else localStorage.removeItem(KEY); }
    catch (e) { /* private mode: nothing is remembered, nothing breaks */ }
  }
  function setSkip(on) {
    try { if (on) sessionStorage.setItem(skipKey, '1'); else sessionStorage.removeItem(skipKey); } catch (e) {}
  }

  /* The ONE mapping from a saved size to the sizes a page offers -- the same name if the page
     has it; a saved single size takes the split size holding it (M -> S/M); a saved split size
     takes every single size inside it (S/M -> S and M). Nothing else matches: a saved XXL on a
     page that stops at L/XL picks nothing rather than a guess. The head script in
     snippets/size-prompt.liquid carries the same function; keep the two in step. */
  function mapSaved(sz, names) {
    if (names.indexOf(sz) >= 0) return [sz];
    if (sz.indexOf('/') < 0) return names.filter(function (n) { return n.split('/').indexOf(sz) >= 0; });
    var parts = sz.split('/');
    return names.filter(function (n) { return parts.indexOf(n) >= 0; });
  }

  /* ---------------- collection / search: the prompt ---------------- */
  function initPrompt(root) {
    var cfg;
    try { cfg = JSON.parse(root.querySelector('[data-size-prompt-config]').textContent); } catch (e) { return; }
    var btns = cfg.b || [];
    var names = btns.map(function (b) { return b.t; });
    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-size]'));
    var remember = Array.prototype.slice.call(root.querySelectorAll('[data-size-remember]'));
    var miss = root.querySelector('[data-size-miss]');
    var label = root.querySelector('[data-size-label]');

    function activeValues() { return new URLSearchParams(location.search).getAll(PARAM); }
    // A button is on when its own name is in the URL. The extra values it sends (S/M under
    // M, Freesize under everything) do not turn other buttons on.
    function onNames() {
      var act = activeValues();
      return names.filter(function (n) { return act.indexOf(n) >= 0; });
    }
    function valuesFor(list) {
      var out = [];
      btns.forEach(function (b) {
        if (list.indexOf(b.t) < 0) return;
        b.v.forEach(function (v) { if (out.indexOf(v) < 0) out.push(v); });
      });
      return out;
    }

    /* Craft lists one removable chip per active value. On Dresses a pick of M is five values
       (M, S/M and three Freesize ones), so the chips the prompt sent are hidden -- its own
       folded line, with Change, stands in for them. A chip's link is the current URL minus
       what it removes, which is how that is found without touching facets.liquid.
       Two limits, both measured on staging 2026-10-22:
       - ONLY the chip rows (.active-facets). The Size dropdown's own "Reset" and the mobile
         drawer's "Clear" are where a shopper manages sizes on purpose, and stay.
       - a link is the prompt's when EVERYTHING it removes is a size the prompt sent. That
         takes "Remove all" too when sizes are the only filter, and leaves it when a price or
         colour is also on -- it would remove those as well. */
    function filterPairs(search) {
      var out = [];
      new URLSearchParams(search).forEach(function (v, k) { if (k.indexOf('filter.') === 0) out.push(k + '=' + v); });
      return out;
    }
    function paintChips(on) {
      var covered = valuesFor(on).map(function (v) { return PARAM + '=' + v; });
      var cur = filterPairs(location.search);
      document.querySelectorAll('.active-facets facet-remove a[href]').forEach(function (a) {
        var keep;
        try { keep = filterPairs(new URL(a.getAttribute('href'), location.origin).search); } catch (e) { return; }
        var removed = cur.filter(function (x) { return keep.indexOf(x) < 0; });
        var mine = removed.length > 0 && removed.every(function (x) { return covered.indexOf(x) >= 0; });
        a.closest('facet-remove').style.display = mine ? 'none' : '';
      });
    }

    function sync() {
      var on = onNames();
      buttons.forEach(function (b) { b.setAttribute('aria-pressed', String(on.indexOf(b.dataset.size) >= 0)); });
      if (on.length) {
        root.classList.add('is-done');
        label.textContent = on.join(' or ');
        miss.hidden = true;
      } else {
        root.classList.remove('is-done');
      }
      paintChips(on);
    }

    function apply(list) {
      var u = new URL(location.href);
      u.searchParams.delete(PARAM);
      u.searchParams.delete('page');
      valuesFor(list).forEach(function (v) { u.searchParams.append(PARAM, v); });
      // a size cleared here stays cleared on reload; a size picked here lifts that
      setSkip(!list.length);
      var qs = u.searchParams.toString();
      if (typeof FacetFiltersForm !== 'undefined' && FacetFiltersForm.renderPage) {
        // Craft's own path -- the one the Size dropdown takes -- so infinite scroll and sold-out
        // last resync exactly as they do for any filter change
        FacetFiltersForm.renderPage(qs);
        sync();
      } else {
        location.assign(u.pathname + (qs ? '?' + qs : ''));
      }
    }

    buttons.forEach(function (b) {
      b.addEventListener('click', function () {
        var n = b.dataset.size, on = onNames();
        var clearing = on.length === 1 && on[0] === n;
        if (!clearing && remember[0].checked) saveSize(n);
        apply(clearing ? [] : [n]);
        if (clearing) b.focus();
      });
    });
    root.querySelector('[data-size-change]').addEventListener('click', function () {
      root.classList.remove('is-done');
      var b = root.querySelector('[data-size][aria-pressed="true"]') || buttons[0];
      if (b) b.focus();
    });
    var guide = root.querySelector('[data-size-guide]');
    if (guide) guide.addEventListener('click', function () {
      if (typeof window.toggleSizeGuide === 'function') window.toggleSizeGuide(guide);
    });
    remember.forEach(function (c) {
      c.checked = !!savedSize();
      c.addEventListener('change', function () {
        remember.forEach(function (x) { x.checked = c.checked; });
        var on = onNames();
        // ticking saves the size on screen; with none picked yet it saves the next pick
        if (!c.checked) saveSize(null);
        else if (on.length === 1) saveSize(on[0]);
      });
    });

    // A saved size this page does not make: say so, once, on a fresh landing only.
    var sv = savedSize();
    if (sv && !activeValues().length && !sessionStorage.getItem(skipKey) && !mapSaved(sv, names).length) {
      var where = location.pathname.indexOf('/search') === 0 ? 'in these results' : 'in this collection';
      miss.textContent = 'Your saved size, ' + sv + ', isn’t made ' + where + '.';
      miss.hidden = false;
    }

    // facets.js swaps #ProductGridContainer's children on every filter change, so watching
    // it is enough to stay in step
    var grid = document.getElementById('ProductGridContainer');
    if (grid) {
      new MutationObserver(function (muts) {
        if (!muts.some(function (m) { return m.addedNodes.length; })) return;
        // a size the shopper removed from the dropdown or the chips stays removed on reload
        if (!activeValues().length && root.classList.contains('is-done')) setSkip(true);
        sync();
      }).observe(grid, { childList: true });
    }
    window.addEventListener('popstate', function () { setTimeout(sync, 0); });
    sync();
  }

  /* ---------------- product page: preselect the saved size ---------------- */
  function initProduct() {
    var sv = savedSize();
    if (!sv) return;
    if (new URLSearchParams(location.search).has('variant')) return; // an explicit variant wins
    var picker = document.querySelector('product-info[id^="MainProduct-"] variant-selects') ||
      document.querySelector('variant-selects');
    if (!picker) return;
    var inputs = Array.prototype.slice.call(
      picker.querySelectorAll('input[type="radio"][data-option-name="Size" i]'));
    if (!inputs.length) return;
    var m = mapSaved(sv, inputs.map(function (i) { return i.value; }));
    if (m.length !== 1) return; // a saved S/M on a style sold as S and M is two sizes: no guess
    var input = inputs.filter(function (i) { return i.value === m[0]; })[0];
    if (input.classList.contains('disabled') || input.disabled) {
      var p = document.createElement('p');
      p.className = 'size-prompt-pdp-note';
      p.setAttribute('role', 'status');
      p.textContent = 'Your saved size, ' + m[0] + ', is sold out in this style.';
      picker.insertAdjacentElement('afterend', p);
      picker.addEventListener('change', function () { p.remove(); }, { once: true });
      return;
    }
    if (input.checked) return;
    input.checked = true;
    // Craft's own change event, so price, button, stock text and URL update as for a click
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function start() {
    var root = document.querySelector('[data-size-prompt]');
    if (root) { initPrompt(root); return; }
    if (!document.querySelector('variant-selects')) return;
    // the picker's listeners are attached when Craft's elements upgrade; a change event
    // dispatched before that would tick the radio and update nothing else
    var ready = window.customElements
      ? Promise.all([customElements.whenDefined('variant-selects'), customElements.whenDefined('product-info')])
      : Promise.resolve();
    ready.then(initProduct);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
